type AspectRatiosObject = {
  [key: string]: [number, number];
};

export const ASPECT_RATIOS: AspectRatiosObject = {
  '16:9': [800, 450],
};
